import { render, staticRenderFns } from "./ViewClient.vue?vue&type=template&id=e7b024a6&scoped=true"
import script from "./ViewClient.vue?vue&type=script&lang=js"
export * from "./ViewClient.vue?vue&type=script&lang=js"
import style0 from "./ViewClient.vue?vue&type=style&index=0&id=e7b024a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b024a6",
  null
  
)

export default component.exports